import { Box, Paper, Skeleton, Typography } from '@mui/material';

interface ActivitySummaryProps {
  loading: boolean;
  values?: {
    totalContributions: number;
    activeDays: number;
    currentStreak: number;
    longestStreak: number;
  };
}

export default function ActivitySummary({
  loading,
  values,
}: ActivitySummaryProps) {
  const stats = [
    ['Versions published', values?.totalContributions ?? 0],
    ['Active days', values?.activeDays ?? 0],
    ['Current streak', `${values?.currentStreak ?? 0} days`],
    ['Longest streak', `${values?.longestStreak ?? 0} days`],
  ];

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
        gap: 1,
      }}
      aria-label="Project activity summary"
    >
      {stats.map(([label, value]) => (
        <Paper variant="inset" sx={{ p: 2 }} key={label}>
          {loading && !values ? (
            <Skeleton width={54} height={32} />
          ) : (
            <Typography variant="h5" component="p">
              {value}
            </Typography>
          )}
          <Typography variant="caption" color="text.secondary">
            {label}
          </Typography>
        </Paper>
      ))}
    </Box>
  );
}
